import {Routes} from '@angular/router';
import {ProMessagingComponent} from './pro-messaging.component';
import {AuthGuard} from '../core/security/auth-guard.service';
import {ModulesEnum} from '../core/security/modules.enum';
import {RolesEnum} from '../core/security/roles.enum';
import {MenuGroupEnum} from '../core/security/menu-group.enum';

export const routes: Routes = [
  {
    path: 'messages',
    component: ProMessagingComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.ProMessagingGroup,
      package: ModulesEnum.ProMessagingModule,
      permissions: [RolesEnum.ProMessaging_View, RolesEnum.ProMessaging_Edit, RolesEnum.ProMessaging_Delete],
      meta: {
        title: 'Messages',
        override: true,
        description: 'Pro Business SMS Page',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'try',
        showDisabled: false
      }
    }
  },
  {
    path: 'broadcast',
    loadChildren: () => import('./../message-broadcasting/message-broadcasting.module').then(m => m.MessageBroadcastingModule),
    canActivateChild: [AuthGuard],
  },
  {
    path: 'automation',
    loadChildren: () => import('./../pro-messaging-automation/pro-messaging-automation.module').then(m => m.ProMessagingAutomationModule),
    canActivateChild: [AuthGuard],
  },
  {
    path: 'template',
    loadChildren: () => import('./../pro-messaging-template/pro-messaging-template.module').then(m => m.ProMessagingTemplateModule),
    canActivateChild: [AuthGuard],
  },
  {
    path: 'whatsapp-template',
    loadChildren: () => import('./../pro-messaging-whats-app-template/pro-messaging-whats-app-template.module').then(m => m.ProMessagingWhatsAppTemplateModule),
    canActivateChild: [AuthGuard],
  },
  {
    path: 'whatsapp-onboard',
    loadChildren: () => import('./../whats-app-onboard/whats-app-onboard.module').then(m => m.WhatsAppOnboardModule),
    canActivateChild: [AuthGuard],
  },
  {
    path: 'reports',
    loadChildren: () => import('./../pro-messaging-reports/pro-messaging-reports.module').then(m => m.ProMessagingReportsModule),
    canActivateChild: [AuthGuard],
  },
];
